
import { DeploymentStatus } from '../../api/types';


export const getStatusWrapperStyle = (
  theme,
  deploymentStatus,
) => {
  let deploymentStatusColor;

  switch (deploymentStatus) {
    case DeploymentStatus.Succeed:
      deploymentStatusColor = theme.palette.success.dark;
      break;
    case DeploymentStatus.Pending:
      deploymentStatusColor = theme.palette.warning.dark;
      break;
    case DeploymentStatus.InProgress:
      deploymentStatusColor = theme.palette.info.dark;
      break;
    case DeploymentStatus.Failed:
      deploymentStatusColor = theme.palette.error.dark;
      break;
    default:
      deploymentStatusColor = theme.palette.text.primary;
  }
  return { fontWeight: 700, color: deploymentStatusColor };
};

export const getVersionWrapperStyle = (
  theme,
) => ({
  marginLeft: 8,
  padding: 4,
  border: `1px solid ${theme.palette.borderColor.primary}`,
  borderRadius: 4,
});

export const containerStyle = {
  display: 'flex',
  alignItems: 'center',
};
